module.exports = __webpack_public_path__ + "img/log-what-you-do.e3dfafea.gif";